import createReactComponent from '../createReactComponent';
var Sliders = createReactComponent('Sliders', [['line', {
  x1: '4',
  y1: '21',
  x2: '4',
  y2: '14',
  key: '2cpl65'
}], ['line', {
  x1: '4',
  y1: '10',
  x2: '4',
  y2: '3',
  key: '1b26kg'
}], ['line', {
  x1: '12',
  y1: '21',
  x2: '12',
  y2: '12',
  key: 'fxobwr'
}], ['line', {
  x1: '12',
  y1: '8',
  x2: '12',
  y2: '3',
  key: 'bkspcw'
}], ['line', {
  x1: '20',
  y1: '21',
  x2: '20',
  y2: '16',
  key: 'b7lt1r'
}], ['line', {
  x1: '20',
  y1: '12',
  x2: '20',
  y2: '3',
  key: 'inamez'
}], ['line', {
  x1: '1',
  y1: '14',
  x2: '7',
  y2: '14',
  key: 'chos6l'
}], ['line', {
  x1: '9',
  y1: '8',
  x2: '15',
  y2: '8',
  key: '13svv0'
}], ['line', {
  x1: '17',
  y1: '16',
  x2: '23',
  y2: '16',
  key: '1ittwr'
}]]);
export default Sliders;